import { useTranslation } from 'react-i18next'

import { Box } from '@enechain/ecloud-designsystem'
// design/demand/forecast-list.html #dfl-under-dev (L168) のレンチ状 SVG
// (fill:none; stroke:currentColor) と同義の @enechain/ecloud-icons 側アイコン。
import { FaWrenchRegular } from '@enechain/ecloud-icons'

import {
  EMPTY_PANEL_ICON_SIZE,
  EmptyPanel,
} from '~/components/common/EmptyPanel'

type Props = {
  /** アクティブなタブの表示ラベル (= t(tabDef.i18nKey) 済みの文字列) */
  tabLabel: string
}

/**
 * 開発中プレースホルダ (design/demand/forecast-list.html 2026-07-15 ユーザー指示,
 * `#dfl-under-dev` L165-173): 週間タブ選択時、テーブル・フィルタ領域を
 * 隠して同位置に表示する。文言は design 準拠 (月間/年間は押せないタブで、
 * 選択されないためここには来ない。AC-DFL-026)。
 *
 * 面は共通の空状態パネル (UI 辞書 empty-panel.md、 値の正は DS `PageError`) で組む:
 * 「開発中」 の glyph はレンチ (同 doc の glyph 表)、 色は状態によらず `Object.disabled`。
 * 器の無い場所へ単独で置くので `--boxed` (破線 1px `Border.midEmphasis`・角丸 lg・
 * `Surface.primary`) で囲む。 共通の EmptyPanel は `--boxed` を持たないので、 枠だけ
 * ここで足す。
 */
export const UnderDevPlaceholder = ({
  tabLabel,
}: Props): React.ReactElement => {
  const { t } = useTranslation()

  return (
    <Box
      borderWidth="1px"
      borderStyle="dashed"
      borderColor="Border.midEmphasis"
      borderRadius="lg"
      backgroundColor="Surface.primary"
    >
      <EmptyPanel
        description={t('page:demandForecastList.underDev.description')}
        icon={
          <FaWrenchRegular boxSize={EMPTY_PANEL_ICON_SIZE} aria-hidden="true" />
        }
        title={t('page:demandForecastList.underDev.title', { tabLabel })}
      />
    </Box>
  )
}
